import { render, staticRenderFns } from "./HomeContact.vue?vue&type=template&id=dd9b91bc&scoped=true"
import script from "./HomeContact.vue?vue&type=script&lang=js"
export * from "./HomeContact.vue?vue&type=script&lang=js"
import style0 from "./HomeContact.vue?vue&type=style&index=0&id=dd9b91bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9b91bc",
  null
  
)

export default component.exports